module.exports = __webpack_public_path__ + "calendar.8461ccb9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/calendar-hub/calendar.png
// module id = 757
// module chunks = 0